import React, { ReactNode } from 'react';
import { defineMessage } from 'react-intl';

import { NavigationBar, Page, PageContent } from '@ocx/ui';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';

type StoreLocatorLayoutProps = {
  children: ReactNode;
};

export const StoreLocatorLayout: React.FC<StoreLocatorLayoutProps> = ({ children }) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'storeLocator:htmlTitle',
          defaultMessage: 'Store locator',
          description: 'HTML title tag for Store locator Page',
        })}
      />
      <NavigationBar left={<BackButton />} center={<VendorLogo />} />
      <PageContent bgcolor="background.paper" overflow="hidden">
        {children}
      </PageContent>
    </Page>
  );
};
